import {useState} from 'react';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';

export default function UbiAgreeBottomSheetEu() {
  const {t} = useInferableTranslation();
  const [isDetail, setIsDetail] = useState(false);

  if (isDetail) {
    return (
      <div
        className="bottom_sheet"
        role="dialog"
        aria-modal="true"
        aria-labelledby="bottomSheetTitle"
        aria-describedby="bottomSheetDesc"
      >
        <div className="bottom_sheet_header">
          <h2
            id="bottomSheetTitle"
            className="bottom_sheet_title"
            style={{whiteSpace: 'pre-wrap'}}
          >
            {t('ctn_ubi_consent_detail_bottom_title_eu')}
          </h2>
          <button
            type="button"
            className="btn btn_ic"
            aria-label="close"
            onClick={() => setIsDetail(false)}
          >
            <span
              className="ic ic_close_20px"
              aria-hidden="true"
            ></span>
          </button>
        </div>
        <div className="bottom_sheet_inner">
          <div
            className="bottom_sheet_contents"
            id="bottomSheetDesc"
          >
            <strong className="bottom_sheet_title_sub">{t('msg_ubi_consent_detail_bottom_message_eu')}</strong>
          </div>
          <div className="bottom_sheet_footer">
            <button
              type="button"
              className="btn btn_large btn_filled"
              onClick={() => setIsDetail(false)}
            >
              {t('ctn_ubi_consent_detail_bottom_confirm_button_eu')}
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="bottom_sheet"
      role="dialog"
      aria-modal="true"
      aria-labelledby="bottomSheetTitle"
      aria-describedby="bottomSheetDesc"
    >
      <div className="bottom_sheet_header">
        <h2
          id="bottomSheetTitle"
          className="bottom_sheet_title"
          style={{whiteSpace: 'pre-wrap'}}
        >
          {t('ctn_ubi_consent_bottom_title_eu')}
        </h2>
        <button
          type="button"
          className="btn btn_ic"
          aria-label="close"
          onClick={() => window.bottomSheetClose(false)}
        >
          <span
            className="ic ic_close_20px"
            aria-hidden="true"
          ></span>
        </button>
      </div>
      <div className="bottom_sheet_inner">
        <div
          className="bottom_sheet_contents"
          id="bottomSheetDesc"
        >
          <strong className="bottom_sheet_title_sub">{t('msg_ubi_consent_bottom_message_eu')}</strong>

          <button
            type="button"
            className="consent_view_btn"
            onClick={() => setIsDetail(true)}
          >
            <span className="consent_view_text body_large_r">{t('ctn_ubi_consent_bottom_optional_eu')}</span>
            <span
              className="ic ic_arrow_forward_14px"
              aria-hidden="true"
            ></span>
          </button>
        </div>

        <div className="bottom_sheet_footer bottom_sheet_footer_vertical">
          <button
            type="button"
            className="btn btn_large btn_filled"
            onClick={() => window.bottomSheetClose(true)}
          >
            {t('ctn_ubi_consent_bottom_confirm_button_eu')}
          </button>

          <button
            type="button"
            className="btn btn_large btn_outline"
            onClick={() => window.bottomSheetClose(false)}
          >
            {t('ctn_ubi_consent_bottom_back_button_eu')}
          </button>
        </div>
      </div>
    </div>
  );
}
